import { callApi } from '@/api/api.config';
import { RequestConfig } from '@/api/api.types';
import { ProjectMapData } from '@/modules/Projects/Projects.schema';
import { useQuery } from '@tanstack/react-query';

export const getProjectMapData = async (projectId: string, config?: RequestConfig): Promise<ProjectMapData> => {
  if (!projectId) {
    return Promise.reject(new Error('Invalid project ID'));
  }
  const response = await callApi({ method: 'GET', url: `/customer/projects/${projectId}/map/`, params: config?.params });

  const data = response.data;

  // If center is an array, convert it to an object
  if (Array.isArray(data.center) && data.center.length === 2) {
    data.center = {
      lat: data.center[0],
      long: data.center[1],
    };
  }

  return data;
};

export const useProjectMap = (projectId: string) =>
  useQuery({
    queryKey: ['Project Map', projectId],
    queryFn: () => getProjectMapData(projectId),
    enabled: !!projectId,
  });
